import ReactDOM from "react-dom/client";
import * as Contentful from "contentful";
import React from "react";
import App from "./App";

import "./index.css";

const contentfulSpaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const contentfulAccessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

if (!contentfulSpaceId || !contentfulAccessToken) {
	throw new Error("Contentful environment variables not set");
}

export const contentfulClient = Contentful.createClient({
	space: contentfulSpaceId,
	accessToken: contentfulAccessToken
});

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

root.render(
	<React.StrictMode>
		<App/>
	</React.StrictMode>
);